import { CSSProperties, FC } from "react";
import { useSelector } from "react-redux";
import classes from "./SiteNameComponent.module.css";
import { RootState } from "../app/Store";
import { UserAccessType } from "../user/Models";
import { TextEnum } from "../../SolarGikLib/TextStyles";
import LightTooltipOnEllipsis from "../../SolarGikLib/tooltip/LightTooltipOnEllipsis";

interface ISiteNameComponentProps {
  siteId: string;
  asTitle?: boolean;
  wrapperStyle?: CSSProperties;
}

const SiteNameComponent: FC<ISiteNameComponentProps> = ({ siteId, asTitle = false, wrapperStyle }) => {
  const siteDisplayName = useSelector(
    (state: RootState) => state.multiSitesMetadata.sites[siteId]?.displayName
  );
  const siteCode = useSelector((state: RootState) => state.multiSitesMetadata.sites[siteId]?.siteCode);
  const isEngineer = useSelector((state: RootState) => state.user.userType >= UserAccessType.Engineer);
  const defaultName = siteDisplayName || siteCode;
  const displayTwoNames = isEngineer && siteDisplayName;
  if (asTitle) {
    return (
      <LightTooltipOnEllipsis
        title={defaultName}
        customTooltipSx={{ fontSize: { xs: 12, lg: 14 } }}
        wrapperStyle={wrapperStyle}
      >
        <div>
          {displayTwoNames && (
            <div
              className={`${TextEnum.h7} ${classes["surround-with-parenthesis"]} ${classes["site-name-with-ellipsis"]}`}
            >
              {siteCode}
            </div>
          )}
          <div className={classes["site-name-with-ellipsis"]}>{defaultName}</div>
        </div>
      </LightTooltipOnEllipsis>
    );
  }

  return (
    <div>
      {displayTwoNames && (
        <div className={`${TextEnum.h7} ${classes["surround-with-parenthesis"]}`}>{siteCode}</div>
      )}
      <div>{defaultName}</div>
    </div>
  );
};

export type SiteNameFormatterFunc = (siteId: string) => string;

export function useSiteNamesFormatter(): SiteNameFormatterFunc {
  const multiSitesMetadata = useSelector((state: RootState) => state.multiSitesMetadata);
  const isEngineer = useSelector((state: RootState) => state.user.userType >= UserAccessType.Engineer);
  return (siteId: string) => {
    if (!siteId) {
      return "";
    }
    const siteDisplayName = multiSitesMetadata.sites[siteId]?.displayName;
    const siteCode = multiSitesMetadata.sites[siteId]?.siteCode;
    if (isEngineer && siteDisplayName && siteCode) {
      return `${siteCode} (${siteDisplayName})`;
    }
    return siteDisplayName || siteCode || siteId;
  };
}

export default SiteNameComponent;
